export const getQueryParams = (urlString: string) => {
  try {
    const url = new URL(urlString);

    return Object.fromEntries(url.searchParams);
  } catch (error) {
    console.error('Передан невалидный URL', error);
    return {};
  }
};
